var companys = [
    {
        id: 1,
        name: "江苏省苏州市中级人民法院"
    },
    {
        id: 5686196154269696,
        name: "苏州市姑苏区人民法院"
    },
    {
        id: 5686196154662912,
        name: "苏州市沧浪区人民法院"
    },
    {
        id: 5686196154793984,
        name: "苏州市平江区人民法院"
    },
    {
        id: 5686196155056128,
        name: "苏州市金阊区人民法院"
    },
    {
        id: 5686196155318272,
        name: "苏州市虎丘区人民法院"
    },
    {
        id: 5686196155580416,
        name: "江苏省张家港市人民法院"
    },
    {
        id: 5686196155842560,
        name: "江苏省常熟市人民法院"
    },
    {
        id: 5686196156104704,
        name: "江苏省昆山市人民法院"
    },
    {
        id: 5686196156366848,
        name: "江苏省太仓市人民法院"
    },
    {
        id: 5686196156760064,
        name: "苏州市吴江区人民法院"
    },
    {
        id: 5686196157022208,
        name: "苏州市吴中区人民法院"
    },
    {
        id: 5686196157153280,
        name: "苏州市相城区人民法院"
    },
    {
        id: 5686196157415424,
        name: "苏州市工业园区人民法院"
    }
]
export default companys


//////////////////
// WEBPACK FOOTER
// ./static/js/company.js
// module id = null
// module chunks = 